export enum RepairServices {
  Cleaning = 'Cleaning',
  UltrasonicCleaning = 'Ultrasonic Cleaning',
  Diagnostic = 'Diagnostic',
  MachineLevelRepair = 'Machine-Level Repair',
  BoardLevelRepair = 'Board-Level Repair',
}

export const HiddenRepairServices = [
  RepairServices.Diagnostic,
  RepairServices.MachineLevelRepair,
  RepairServices.BoardLevelRepair,
].map((s) => s.toString())
